import { safeJson } from "src/app/helpers/Index";
import React from "react";
import { ClubContext } from "src/app/helpers/ClubContext";
import { FitSponsorText } from "src/app/helpers/FitSponsorText";
import { Col, Row } from "react-bootstrap";
import { Fixture, Goal, Player } from "src/app/interfaces/Index";
import { FixtureService, GoalService, PlayerService } from "src/app/services/Index";
import "./ScoreboardTeam.css";
import { PlayerPosition } from "src/app/enums/PlayerPosition";

type Props = {};
type State = {
	teamName: string;
	currentIndex: number;
	currentPlayer: Player;
	team: Player[];
};
export class ScoreboardTeam extends React.Component<Props, State> {

	constructor(props: Props) {
		super(props);
		this.state = { currentPlayer: new Player, currentIndex: 0, team: [], teamName: "" };
	}

	componentDidMount() {
		this.getTeam().then(() => this.getAwayTeam());
		let loop = setInterval(() => this.setIndex(), 5000);
	}

	setIndex() {
		let index = this.state.currentIndex === this.state.team.length - 1 ? 0 : this.state.currentIndex + 1;
		let currentItem = this.state.team[index];
		this.setState({ currentIndex: index, currentPlayer: currentItem });
	}

	render() {
		return (
			<div id="scoreboard-wrapper2" style={{ textAlign: "center", width: 576, height: 432 }}>
				{this.renderHeading()}
				<Row style={{ height: "79%" }}>
					<Col style={{ position: "relative" }}>
						<h1 style={{ paddingLeft: 20, paddingTop: 20, fontSize:"40pt", float: "left", flex: 0.3, flexDirection: "column", flexWrap: "wrap", alignContent: "center", whiteSpace: "break-spaces", textAlign: "center" }}>{this.state.currentPlayer.playerNumber}. {this.state.currentPlayer?.playerName}</h1>
						<br />
						{this.renderSponsorship()}
					</Col>
					<Col style={{ position: "relative" }}><img src={this.state.currentPlayer?.mugshotUrl} width="299" style={{ position: "absolute", bottom: -20, right: -20 }} /></Col>
				</Row>
			</div>
		);
	}

	async getAwayTeam() {
		const fixRes = await safeJson(FixtureService.getLatest());
		if (fixRes && fixRes.error) {
		}
		let fixture: Fixture = fixRes;

		// Same as the away board: no fixture, no squad. Leave what's up there.
		if (!fixture) return;

		const res = await safeJson(PlayerService.getByTeam(fixture.teamId));
		if (res && res.error) {
		}
		let all: Player[] = Array.isArray(res) ? res : [];

		if (!all.length) return;

		let goalKeeper = all.filter(x => x.playerStatus === 0 && x.playerPosition === 0).sort(({ playerNumber: a }, { playerNumber: b }) => a - b)
		let starting = all.filter(x => x.playerStatus === 0 && x.playerPosition > 1).sort(({ playerNumber: a }, { playerNumber: b }) => a - b);
		let subs = all.filter(x => x.playerStatus === 10).sort(({ playerNumber: a }, { playerNumber: b }) => a - b);
		let allPlayers = [...goalKeeper, ...starting, ...subs];
		this.setState({ teamName: fixture.team?.teamNameShort, team: [...this.state.team, ...allPlayers] });
	}

	async getTeam() {
		const res = await safeJson(PlayerService.getHomeTeam());
		if (res && res.error) {
		}
		let all: Player[] = res

		let goalKeeper = all.filter(x => x.playerStatus === 0 && x.playerPosition === 0).sort(({ playerNumber: a }, { playerNumber: b }) => a - b)
		let starting = all.filter(x => x.playerStatus === 0 && x.playerPosition > 1).sort(({ playerNumber: a }, { playerNumber: b }) => a - b);
		let subs = all.filter(x => x.playerStatus === 10).sort(({ playerNumber: a }, { playerNumber: b }) => a - b);
		let allPlayers = [...goalKeeper, ...starting, ...subs];
		this.setState({ team: allPlayers, currentPlayer: allPlayers[0] });
	}

	renderHeading() {
		var teamNameTemp = "IRON";
		if (this.state.currentPlayer.teamId !== ClubContext.homeTeamId) {
			teamNameTemp = this.state.teamName;
			if (this.state.currentPlayer.playerStatus !== 0) {
				return (
					<Row>
						<h1 className="team-heading" style={{fontSize:"35pt"}}>{teamNameTemp + " - SUBS"}</h1>
					</Row>);
			} else {
				return (
					<Row>
						<h1 className="team-heading" style={{fontSize:"35pt"}}>{teamNameTemp + " - STARTING"}</h1>
					</Row>);
			}
		}
		else{
			if (this.state.currentPlayer.playerStatus !== 0) {
				return (
					<Row>
						<h1 className="team-heading" style={{fontSize:"40pt"}}>{teamNameTemp + " - SUBS"}</h1>
					</Row>);
			} else {
				return (
					<Row>
						<h1 className="team-heading" style={{fontSize:"40pt"}}>{teamNameTemp + " - STARTING"}</h1>
					</Row>);
			}
		}
	}

	renderSponsorship() {
		if (this.state.currentPlayer.teamId === ClubContext.homeTeamId) {
			return (
				<div style={{ position: "absolute", bottom: 0, left: 20, alignContent: "center", zIndex: 99 }}>
					<h4 style={{ width: "100%" }}>SPONSORED BY:</h4>
					{this.state.currentPlayer?.sponsorText
						? <FitSponsorText text={this.state.currentPlayer.sponsorText || ""}/>
						: <img src={this.state.currentPlayer?.sponsor?.imageDark} width="95%" />}
				</div>
			);
		}
		else {
			return;
		}

	}
}